import { useEffect, useState } from 'react';
import axios from 'axios';

const usePermission = (moduleName) => {
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const roleId = Number(localStorage.getItem("role_id"));

        // SuperAdmin ise tüm izinler açık
        if (roleId === 3) {
          setPermissions({
            canView: true,
            canEdit: true,
            canDelete: true,
            canTrash: true,
            canCreate: true,
            canSort: true,
          });
          return;
        }

        const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/my-permissions`, {
          headers: { Authorization: `Bearer ${token}` },
        });


        const modulePerm = resp.data.permissions.find(
          (p) => p.module_name === moduleName || p.module_key === moduleName
        );

        setPermissions({
          canView: modulePerm?.view_permission || modulePerm?.full_access,
          canEdit: modulePerm?.edit_permission || modulePerm?.full_access,
          canDelete: modulePerm?.delete_permission || modulePerm?.full_access,
          canTrash: modulePerm?.trash_permission || modulePerm?.full_access,
          canCreate: modulePerm?.create_permission || modulePerm?.full_access,
          canSort: modulePerm?.sort_permission || modulePerm?.full_access,
        });
      } catch (err) {
        console.error("Yetkiler alınamadı:", err);
        setPermissions({
          canView: false,
          canEdit: false,
          canDelete: false,
          canTrash: false,
          canCreate: false,
          canSort: false
        });
      }
    };

    fetchPermissions();
  }, [moduleName]);

  return permissions;
};

export default usePermission;
